export function getCurrencyLabel(language, currency) {
  // English (US)
  if (language === "en-US" && currency === "SEK") {
    return "SEK";
  }
  if (language === "en-US" && currency === "EUR") {
    return "EUR";
  }
  if (language === "en-US" && currency === "NOK") {
    return "NOK";
  }
  if (language === "en-US" && currency === "DKK") {
    return "DKK";
  }

  // Swedish (SE)
  if (language === "sv-SE" && currency === "SEK") {
    return "SEK";
  }
  if (language === "sv-SE" && currency === "EUR") {
    return "EUR";
  }
  if (language === "sv-SE" && currency === "NOK") {
    return "NOK";
  }
  if (language === "sv-SE" && currency === "DKK") {
    return "DKK";
  }

  // Finnish (FI)
  if (language === "fi-FI" && currency === "SEK") {
    return "SEK";
  }
  if (language === "fi-FI" && currency === "EUR") {
    return "EUR";
  }
  if (language === "fi-FI" && currency === "NOK") {
    return "NOK";
  }
  if (language === "fi-FI" && currency === "DKK") {
    return "DKK";
  }

  // Norwegian (NO)
  if (language === "nb-NO" && currency === "SEK") {
    return "SEK";
  }
  if (language === "nb-NO" && currency === "EUR") {
    return "EUR";
  }
  if (language === "nb-NO" && currency === "NOK") {
    return "NOK";
  }
  if (language === "nb-NO" && currency === "DKK") {
    return "DKK";
  }

  // Danish (DK)
  if (language === "da-DK" && currency === "SEK") {
    return "SEK";
  }
  if (language === "da-DK" && currency === "EUR") {
    return "EUR";
  }
  if (language === "da-DK" && currency === "NOK") {
    return "NOK";
  }
  if (language === "da-DK" && currency === "DKK") {
    return "DKK";
  }

  // Default fallback
  if (currency === null || currency === undefined) {
    if (language === "sv-SE") {
      return "kr";
    } else {
      return "SEK";
    }
  }
}

export default getCurrencyLabel;
